const Terms = () => {
  return(
    <div style={{margin:"300px"}}>
      <h1>Terms and services</h1>
      <h3>work in progress</h3>
    </div>
  );
};

export default Terms;